module.exports = __webpack_public_path__ + "static/media/dislike-hover.45d56043.png";